import { TrainingAPI } from "../../api/TrainingAPI";

const trainingAPI = new TrainingAPI();

export const BASELINE_SET_LOADING = "[BASELINE]_SET_LOADING";
export const BASELINE_SET_FILTER = "[BASELINE]_SET_FILTER";
export const BASELINE_SET_SORT_BY = "[BASELINE]_SET_SORT_BY";
export const BASELINE_SET_DATA = "[BASELINE]_SET_DATA";

export const setBaselineLoading = (loading) => ({
  type: BASELINE_SET_LOADING,
  payload: loading,
});

export const setBaselineFilterDate = (date) => ({
  type: BASELINE_SET_FILTER,
  payload: { date },
});

export const setBaselineFilterPosition = (position) => ({
  type: BASELINE_SET_FILTER,
  payload: { position },
});

export const setBaselineFilterPlayerGroup = (playerGroup) => ({
  type: BASELINE_SET_FILTER,
  payload: { playerGroup },
});

export const setBaselineSortBy = (sortBy) => ({
  type: BASELINE_SET_SORT_BY,
  payload: sortBy,
});

export const setBaselineData = (data) => ({
  type: BASELINE_SET_DATA,
  payload: data,
});

export const getBaselineData = () => {
  return async (dispatch, getState) => {
    dispatch(setBaselineLoading(true));
    try {
      const {
        sortBy,
        filter: { date, position, playerGroup },
      } = getState().baseline;
      const data = await trainingAPI.getBaselineChart(
        date,
        sortBy,
        position,
        playerGroup
      );
      dispatch(setBaselineData(data));
    } catch (e) {
      console.error(e);
    }
    dispatch(setBaselineLoading(false));
  };
};

export const emailBaselineChart = () => {
  return async (dispatch, getState) => {
    try {
      const {
        filter: { date, position },
        sortBy,
      } = getState().baseline;
      const data = await trainingAPI.emailBaselineChart(date, sortBy, position);
      alert(data);
    } catch (e) {
      console.error(e);
    }
  };
};
